module.exports = __webpack_public_path__ + "img/rubik-light-webfont.77231ca1.77231ca1.svg";